<template>
  <div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      v-b-toggle.comments-sidebar-id
      class="d-flex align-items-center ml-auto"
      size="sm"
      variant="primary"
    >
      <feather-icon
        class="mr-25"
        icon="MessageSquareIcon"
        size="18"
      />
      {{$t('contact.comment')}}
    </b-button>

    <b-sidebar
      id="comments-sidebar-id"
      class="w-500"
      bg-variant="white"
      right
      backdrop
      shadow
      :title="$t('contact.comment')"
    >
      <div class="px-2 comments-form">
        <div>
          <vue-perfect-scrollbar
            class="comment-scroll-area"
            style="height: 690px"
          >
            <b-media
              v-for="(comment, index) in getComments.results"
              :key="index"
              class="mb-2"
            >
              <template #aside>
                <b-avatar
                  v-b-tooltip.hover
                  :src="backendIP + comment.author.photo"
                  class="pull-up"
                  button
                  :title="comment.author.first_name"
                  size="40"
                  variant="primary"
                />
              </template>

              <div
                class="
              d-flex
              justify-content-between
              flex-sm-row flex-column
              mb-sm-0 mb-1
            "
              >
                <h6>{{ comment.author.name }}</h6>
              </div>
              <b-card-text class="mb-25">
                {{ comment.message }}
              </b-card-text>

              <b-button
                v-if="$can('create', 'utils/comment')"
                variant="link"
                class="timeline-item-time text-nowrap font-small-2 pl-0 pr-50"
                @click="replyToComment(comment.message, comment.id)"
              >
                {{ $t('answer') }}
              </b-button>

              <b-button
                v-if="comment.author.id == getUserId"
                variant="link"
                class="timeline-item-time text-nowrap font-small-2 pl-25"
                @click="deleteComment(comment.id)"
              >
                {{ $t('delete') }}
              </b-button>

              <b-media
                v-for="reply_comment in comment.children"
                :key="reply_comment.id"
                class="mt-1"
              >
                <template #aside>
                  <b-avatar
                    v-b-tooltip.hover
                    class="pull-up"
                    button
                    :title="reply_comment.author.first_name"
                    size="40"
                    variant="primary"
                    :src="backendIP + reply_comment.author.photo"
                  />
                </template>

                <div
                  class="
                d-flex
                justify-content-between
                flex-sm-row flex-column
                mb-sm-0 mb-1
              "
                >
                  <h6>{{ reply_comment.author.name }}</h6>
                </div>
                <b-card-text class="mb-0">
                  {{ reply_comment.message }}
                </b-card-text>
                <b-button
                  v-if="reply_comment.author.id == getUserId"
                  variant="link"
                  class="timeline-item-time text-nowrap font-small-2 pl-25"
                  @click="deleteComment(reply_comment.id)"
                >{{ $t('delete') }}
                </b-button>
              </b-media>
            </b-media>
          </vue-perfect-scrollbar>

          <b-form-group>
            <label for="textarea-default">
              <span v-if="reply">
                {{ $t('answer') }}: <strong class="">{{ reply_to_message }}</strong>
                <feather-icon
                  icon="XIcon"
                  class="text-danger mb-50"
                  style="cursor: pointer"
                  @click="CancelReply"
                />
              </span>
              <span v-if="!reply">{{ $t('contact.text_message') }}</span>
            </label>
            <b-form-textarea
              v-model="message"
              name="textarea"
              rows="3"
              :placeholder="$t('contact.text_message')"
            />
          </b-form-group>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            size="md"
            :disabled="!message.length"
            @click="addComment"
          >
            {{ $t('contact.publish') }}
          </b-button>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BButton,
  BFormTextarea,
  BSidebar,
  VBToggle,
  BFormGroup,
  BMedia,
  BCardText,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapActions, mapGetters } from 'vuex'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BSidebar,

    BMedia,
    BCardText,
    BButton,
    BAvatar,
    BFormGroup,
    BFormTextarea,
    VuePerfectScrollbar,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
    Ripple,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['contentType', 'objectId'],
  data() {
    return {
      backendIP: '',
      message: '',
      reply_to_message: '',
      reply: false,
      parent_message_id: null,
    }
  },
  computed: {
    ...mapGetters('taskManager', ['getComments']),
    getUserId() {
      return getUserData().id
    },
  },
  mounted() {
    this.refresh()
  },
  methods: {
    ...mapActions('taskManager', [
      'POST_COMMENT',
      'FETCH_COMMENTS',
      'DELETE_COMMENT',
    ]),

    async refresh() {
      await this.FETCH_COMMENTS({
        object_id: this.objectId,
        content_type: this.contentType,
      })
    },
    async addComment() {
      const newComment = {
        author: this.getUserId,
        object_id: this.objectId,
        content_type: this.contentType,
        message: this.message,
      }
      console.log(newComment)

      if (this.parent_message_id) {
        newComment.parent = this.parent_message_id
      }

      await this.POST_COMMENT(newComment)
      await this.refresh()
      this.message = ''
      this.CancelReply()
    },
    replyToComment(message, id) {
      this.reply_to_message = message
      this.reply = true
      this.parent_message_id = id
    },
    CancelReply() {
      this.reply_to_message = ''
      this.reply = false
      this.parent_message_id = null
    },
    deleteComment(id) {
      this.$bvModal
        .msgBoxConfirm(this.$t('are_you_sure'), {
          title: this.$t('confirm'),
          size: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('yes'),
          cancelTitle: this.$t('no'),
          cancelVariant: 'secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(async value => {
          if (value) {
            await this.DELETE_COMMENT(id)
            this.refresh()
          }
        })
    },
  },
}
</script>

<style lang="scss">
.w-500 .b-sidebar {
  width: 500px !important;
}

.comments-form .text-area {
  position: absolute;
  bottom: 33px;
  left: 0;
  right: 0;
  width: 95%;
  margin: 0 auto;
}

#comments-sidebar-id .b-sidebar-header button {
  margin: 0;
}

#comments-sidebar-id___title__ {
  margin-left: 30px;
  font-size: 19px;
  font-weight: 500;
}

</style>
